/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Nav_TutorialsInputs */

const en_wc_nav_tutorials = /** @type {(inputs: Wc_Nav_TutorialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorials`)
};

/**
* | output |
* | --- |
* | "Tutorials" |
*
* @param {Wc_Nav_TutorialsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_nav_tutorials = /** @type {((inputs?: Wc_Nav_TutorialsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Nav_TutorialsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_nav_tutorials(inputs)
});
export { wc_nav_tutorials as "wc.nav.tutorials" }